<template id="modal-filter">
    <div>
        <div class="filter">
            <a href="" data-target="#myModal" data-toggle="modal">Filter ({{totalFilters}})</a>
        </div>

        <div class="modal fade" id="myModal" role="dialog">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <h2>Filter challenges by:</h2>
                        <div class="options-group">
                            <form class="form-inline">
                                <div class="form-group">
                                    <label class="option-title">Team size</label>
                                    <label class="radio-inline first-option">
                                        <input id="inlineradio1" name="sampleinlineradio" v-model="teamSize" value="team" type="radio">
                                        Team
                                    </label>
                                    <label class="radio-inline second-option">
                                        <input id="inlineradio2" name="sampleinlineradio" v-model="teamSize" value="individual" type="radio">
                                        Individual
                                    </label>
                                </div>
                            </form>
                        </div>
                        <div class="options-group">
                            <form class="form-inline">
                                <div class="form-group">
                                    <label class="option-title">Challenge type</label>
                                    <label class="radio-inline first-option">
                                        <input id="inlineradio1" name="sampleinlineradio" v-model="challengeType" value="step" type="radio">
                                        Step
                                    </label>
                                    <label class="radio-inline second-option">
                                        <input id="inlineradio2" name="sampleinlineradio" v-model="challengeType" value="weightLoss" type="radio">
                                        Weight Loss
                                    </label>
                                </div>
                            </form>
                        </div>
                        <button class="apply" :disabled="!filterBtnAvailable" @click="onApplyFilters" data-dismiss="modal">Apply Filters</button>
                        <button class="clear" :disabled="!filterBtnAvailable" @click="onClearFilters">Clear Filters</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isIndividualChallenge, isTeamChallenge } from './utils'
import { variables } from './constants';

export default {
  template: '#modal-filter',
  data: function() {
    return {
      teamSize: '',
      challengeType: '',
      totalFilters: 0
    }
  },
  computed: {
    filterBtnAvailable: function() {
      return this.teamSize !== this.challengeType
    }
  },
  methods: {
    onApplyFilters: function() {
      var challengeList = this.$store.state.challengeList;
      const sweepstakesChallenge = challengeList.filter((challenge) => challenge.challenge_type === variables.SWEEPSTAKES)

      if (this.teamSize === variables.TEAM) {
        challengeList = challengeList.filter(function(challenge) { return isTeamChallenge(challenge) })
      } else if (this.teamSize === variables.INDIVIDUAL) {
        challengeList = challengeList.filter(function(challenge) { return isIndividualChallenge(challenge); })
      }

      if (this.challengeType === variables.STEP) {
        challengeList = challengeList.filter(function(challenge) { return challenge.challenge_type.includes(variables.STEP) })
      } else if (this.challengeType === variables.WEIGHT_LOSS) {
        challengeList = challengeList.filter(function(challenge) { return !challenge.challenge_type.includes(variables.STEP) })
      }

      challengeList = challengeList.concat(sweepstakesChallenge);
      this.calculateTotalFilters();
      this.$store.commit('updateModalFilterValues', { team: this.teamSize, type: this.challengeType });
      this.$store.commit('updateModalFilteredChallengeList', challengeList);
    },
    onClearFilters: function() {
      this.teamSize = '';
      this.challengeType = '';

      this.calculateTotalFilters();
      this.$store.commit('resetChallengeList');
    },
    calculateTotalFilters: function() {
      if (this.teamSize === this.challengeType) {
        this.totalFilters = 0
      } else if (this.teamSize === '' || this.challengeType === '') {
        this.totalFilters = 1
      } else {
        this.totalFilters = 2
      }
    }
  }
}
</script>
